var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebRelations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 22.5,
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8873_2583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 23C15 24.1819 15.2328 25.3522 15.6851 26.4442C16.1374 27.5361 16.8003 28.5282 17.636 29.364C18.4718 30.1997 19.4639 30.8626 20.5558 31.3149C21.6478 31.7672 22.8181 32 24 32C25.1819 32 26.3522 31.7672 27.4442 31.3149C28.5361 30.8626 29.5282 30.1997 30.364 29.364C31.1997 28.5282 31.8626 27.5361 32.3149 26.4442C32.7672 25.3522 33 24.1819 33 23C33 20.6131 32.0518 18.3239 30.364 16.636C28.6761 14.9482 26.3869 14 24 14C21.6131 14 19.3239 14.9482 17.636 16.636C15.9482 18.3239 15 20.6131 15 23Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5996 20H32.3996",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5996 26H32.3996",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4997 14C21.815 16.6996 20.9219 19.8179 20.9219 23C20.9219 26.1821 21.815 29.3004 23.4997 32",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14C26.1847 16.6996 27.0778 19.8179 27.0778 23C27.0778 26.1821 26.1847 29.3004 24.5 32",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8873_2583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebRelations);
export default __webpack_public_path__ + "static/media/web-relations.7d94e96ee5f99f35b8cec81a8610c83b.svg";
export { ForwardRef as ReactComponent };